<template>
  <div>
    <el-alert
      v-if="fifoPolicyLoaded && !outboundFifoEnabled"
      class="layer-policy-note"
      title="当前未启用先进先出，库存层记录不代表现存量；请以库存查询中的库存数量和可用库存为准。"
      type="info"
      :closable="false"
      show-icon
    />
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="产品编码"><el-input v-model="query.materialCode" placeholder="产品编码" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="产品名称"><el-input v-model="query.materialName" placeholder="产品名称" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="仓库路径"><el-input v-model="query.wareHouseId" placeholder="可输入前缀" size="small" clearable style="width:160px" /></el-form-item>
      <el-form-item label="批号"><el-input v-model="query.batchNo" placeholder="批号" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('inventory:stockLayer:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button size="small" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" width="60" align="center" />
      <el-table-column prop="materialCode" label="产品编码" min-width="130" />
      <el-table-column prop="materialName" label="产品名称" min-width="140" />
      <el-table-column prop="wareHousePath" label="库位路径" min-width="180" show-overflow-tooltip />
      <el-table-column prop="batchNo" label="批号" width="120" show-overflow-tooltip />
      <el-table-column v-if="inventoryQtyShowSupplier" prop="supplierName" label="供应商" min-width="120" show-overflow-tooltip />
      <el-table-column prop="quantity" label="层总量" width="110" align="right" />
      <el-table-column prop="usableQuantity" label="层可用量" width="110" align="right" />
      <el-table-column prop="inboundBizTypeName" label="来源类型" min-width="110" show-overflow-tooltip />
      <el-table-column label="来源单据" min-width="160" show-overflow-tooltip><template slot-scope="scope">{{ sourceCode(scope.row) }}</template></el-table-column>
      <el-table-column prop="inboundTime" label="入库时间" min-width="160" />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="v => { pageSize = v; pageIndex = 1; load() }" @current-change="v => { pageIndex = v; load() }" />
  </div>
</template>
<script>
import request from '../../api/request'
import { authMixin } from './inventoryShared'
import inventoryQtyShowSupplierMixin from '../../mixins/inventory-qty-show-supplier'
import inventoryOutboundFifoMixin from '../../mixins/inventory-outbound-fifo'
export default {
  name: 'StockLayer',
  mixins: [authMixin, inventoryQtyShowSupplierMixin, inventoryOutboundFifoMixin],
  data() { return { query: { materialCode: '', materialName: '', wareHouseId: '', batchNo: '' }, rows: [], pageIndex: 1, pageSize: 20, total: 0, loading: false, fifoPolicyLoaded: false } },
  created() {
    this.loadInventoryQtyShowSupplierPolicy()
    this.loadOutboundFifoPolicy().then(() => { this.fifoPolicyLoaded = true }).catch(() => {})
    this.load()
  },
  methods: {
    sourceCode(row) {
      if (row.inboundBizType === 'onhand') return '—'
      if (row.inboundBizCode) return row.inboundBizCode
      return row.inboundBizTypeName === row.inboundBizType ? (row.inboundBizId || '—') : '来源单据已删除'
    },
    search() { this.pageIndex = 1; this.load() },
    resetQuery() { this.query = { materialCode: '', materialName: '', wareHouseId: '', batchNo: '' }; this.search() },
    load() {
      this.loading = true
      const params = Object.assign({}, this.query, { pageIndex: this.pageIndex, pageSize: this.pageSize })
      request.get('/inventory/stockLayer/list', { params }).then(res => {
        const body = res.data || {}
        this.rows = body.list || []
        this.total = body.totalCount || 0
      }).catch(() => { this.rows = []; this.total = 0 }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.layer-policy-note { margin-bottom: 12px; }
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
</style>
